/* tslint:disable */

declare var Object: any;
export interface QueueServiceInterface {
  "id"?: number;
}

export class QueueService implements QueueServiceInterface {
  "id": number;
  constructor(data?: QueueServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `QueueService`.
   */
  public static getModelName() {
    return "QueueService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of QueueService for dynamic purposes.
  **/
  public static factory(data: QueueServiceInterface): QueueService{
    return new QueueService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'QueueService',
      plural: 'QueueServices',
      path: 'QueueServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/QueueService.ts